import styled from 'styled-components';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import {InputGroup} from 'react-bootstrap';

export const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  margin: 0 15px 90px 15px;
  width: 100%;
  max-width: 1140px;
`

export const StyledFormGroup = styled(Form.Group)`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  align-items: center;
  
  & .inputContainer{
    position: relative;
    flex: 1;
    margin-right: 10px;
    border-radius: 10px 0 0 10px;
    background: #fff;
    z-index: 10;
    box-shadow: 5px 5px 5px rgba(36, 38, 89, 0.1);
    //filter: drop-shadow(-8.49px -8.49px 5px rgba(255, 255, 255, 0.33)) drop-shadow(8.17px 8.17px 12px rgba(36, 38, 89, 0.1));
  }
`;

export const SuggestionsContainer = styled.div`
  position: absolute;
  top: 58px;
  background: #fff;
  width: 100%;
  border-radius: 0 0 10px 10px;
  //filter: drop-shadow(-8.49px -8.49px 5px rgba(255, 255, 255, 0.33)) drop-shadow(8.17px 8.17px 12px rgba(36, 38, 89, 0.1));
  box-shadow: 5px 5px 5px rgba(36, 38, 89, 0.1);
  & .inputDivider {
    height: 0.5px;
    background-color: #BABDBE;
    margin: 0 15px;
  }
  & .react-autosuggest__suggestions-list{
    list-style-type: none;
    padding: 0;
    max-height: 400px;
    overflow: auto;
  }
`

export const SearchSuggestion = styled.div`
  padding: 20px 20px;
  cursor: pointer;
  
  &.highlight{
    background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
  }
`

export const StyledFormControl = styled(Form.Control)`
	&.SearchField{
		height: 58px;
    padding-left: 20px;
    border-width: 0;
    font-family: Manrope, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 16px;
    background: #fff;
    color: #2C2B48;
	}
	&.SearchField:focus{
    border: none;
		box-shadow: none ;
	}
	&.SearchFieldResults{
		height: 60px;
    border-radius: 10px 0px 0px 10px;
    border-width: 0;
    font-family: Manrope, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 16px;
    color: #2C2B48;
	}
	&.SearchFieldResults:focus{
		box-shadow: 5px 5px 5px #ccc ;
	}
`;

export const InputContainer = styled(InputGroup)`
  position: relative;
`

export const ClearSearch = styled(InputGroup.Text)`
  border: none;
  cursor: pointer;
  background: transparent;
  @media screen and (max-width: 768px) {
    right: 0;
  }
  & svg {
    width: 14px;
    height: 14px;
    & path {
      fill: #CDCCCC;
    }
  }
`

export const SearchButton = styled(Button)`
	&.SearchButton{
		background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%) ;
    border-radius: 0px 10px 10px 0px ;
    width: 70px;
    height: 58px;
    border-width: 0 ;
    box-shadow: 5px 5px 5px rgba(54, 115, 237, 0.7);
	}
	&.SearchButton:focus{
		box-shadow: 5px 5px 5px rgb(54 115 237 / 70%);
	}
	&.SearchButtonLink{
		display: flex;
    align-items: center;
    justify-content: center;
	}
	&.SearchButtonResults{
		background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
    border-radius: 0px 10px 10px 0px ;
    width: 59px;
    height: 60px;
    border-width: 0 ;
	}
	&.SearchButtonResults:focus{
		box-shadow: 5px 5px 5px rgb(54 115 237 / 70%);
	}
`;
export const StyledParagraph = styled.p`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 154%;
  text-align: center;
  color: #4F5388;
  margin-bottom: 43px;
`;

export const StyledSpan = styled.span`
  font-family: NunitoSans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 156%;
  text-align: center;
  letter-spacing: 0.01em;
  color: #4F5388;
  margin-left: 15px;
`;
